export const flags = {
    "AE":{
        "url":"https://i.ibb.co/ZKgxXt7/AE.png"
    },
    "AD":{
        "url":"https://i.ibb.co/f27Xsw7/AD.png"
    },
    "AF":{
        "url":"https://i.ibb.co/zHw5LhH/AF.png"
    },
    "AG":{
        "url":"https://i.ibb.co/bsZQCm1/AG.png"
    },
    "AI":{
        "url":"https://i.ibb.co/ZYWGhKN/AI.png"
    },
    "AL":{
        "url":"https://i.ibb.co/mhcwWxY/AL.png"
    },
    "AM":{
        "url":"https://i.ibb.co/xFhd0BC/AM.png"
    },
    "AN":{
        "url":"https://i.ibb.co/1Mms0My/AN.png"
    },
    "AO":{
        "url":"https://i.ibb.co/bJ8Hn6S/AO.png"
    },
    "AQ":{
        "url":"https://i.ibb.co/Q6XG65H/AQ.png"
    },
    "AR":{
        "url":"https://i.ibb.co/w4G6h88/AR.png"
    },
    "AS":{
        "url":"https://i.ibb.co/hKkG1Kc/AS.png"
    },
    "AT":{
        "url":"https://i.ibb.co/NVWLQ7d/AT.png"
    },
    "AU":{
        "url":"https://i.ibb.co/ZgKPtjw/AU.png"
    },
    "AW":{
        "url":"https://i.ibb.co/jgzMJj5/AW.png"
    },
    "AX":{
        "url":"https://i.ibb.co/RNc5308/AX.png"
    },
    "AZ":{
        "url":"https://i.ibb.co/xsH1CmG/AZ.png"
    },
    "BA":{
        "url":"https://i.ibb.co/wRg20tM/BA.png"
    },
    "BB":{
        "url":"https://i.ibb.co/tqJDq8S/BB.png"
    },
    "BD":{
        "url":"https://i.ibb.co/QpmC7vz/BD.png"
    },
    "BE":{
        "url":"https://i.ibb.co/T2bHW32/BE.png"
    },
    "BF":{
        "url":"https://i.ibb.co/X5Kqtk3/BF.png"
    },
    "BG":{
        "url":"https://i.ibb.co/8P4Y9Zf/BG.png"
    },
    "BH":{
        "url":"https://i.ibb.co/RgrHQTK/BH.png"
    },
    "BI":{
        "url":"https://i.ibb.co/x5ddrTy/BI.png"
    },
    "BJ":{
        "url":"https://i.ibb.co/b37VxRY/BJ.png"
    },
    "BL":{
        "url":"https://i.ibb.co/XxHdhWW/BL.png"
    },
    "BM":{
        "url":"https://i.ibb.co/HpYNdjS/BM.png"
    },
    "BN":{
        "url":"https://i.ibb.co/Yb6XXzr/BN.png"
    },
    "BO":{
        "url":"https://i.ibb.co/c3LB7tW/BO.png"
    },
    "BR":{
        "url":"https://i.ibb.co/sjFNw0g/BR.png"
    },
    "BS":{
        "url":"https://i.ibb.co/NVcTtrT/BS.png"
    },
    "BT":{
        "url":"https://i.ibb.co/Z2BNKVJ/BT.png"
    },
    "BV":{
        "url":"https://i.ibb.co/7ymsm1C/BV.png"
    },
    "BW":{
        "url":"https://i.ibb.co/cr78LSk/BW.png"
    },
    "BY":{
        "url":"https://i.ibb.co/CtqjZmk/BY.png"
    },
    "BZ":{
        "url":"https://i.ibb.co/SJVVnTP/BZ.png"
    },
    "CA":{
        "url":"https://i.ibb.co/XkRQZPk/CA.png"
    },
    "CC":{
        "url":"https://i.ibb.co/pWP1KT8/CC.png"
    },
    "CD":{
        "url":"https://i.ibb.co/XWTb289/CD.png"
    },
    "CF":{
        "url":"https://i.ibb.co/q121Wy2/CF.png"
    },
    "CG":{
        "url":"https://i.ibb.co/Xbrb0Fw/CG.png"
    },
    "CH":{
        "url":"https://i.ibb.co/jrYxqLP/CH.png"
    },
    "CI":{
        "url":"https://i.ibb.co/HDf38Dz/CI.png"
    },
    "CK":{
        "url":"https://i.ibb.co/ZH1sDqs/CK.png"
    },
    "CL":{
        "url":"https://i.ibb.co/Q9f08vX/CL.png"
    },
    "CM":{
        "url":"https://i.ibb.co/kgC7hSX/CM.png"
    },
    "CN":{
        "url":"https://i.ibb.co/jWs1Sg3/CN.png"
    },
    "CO":{
        "url":"https://i.ibb.co/sWbjVLm/CO.png"
    },
    "CR":{
        "url":"https://i.ibb.co/MC1N7jF/CR.png"
    },
    "CS":{
        "url":"https://i.ibb.co/5kV6zyS/CS.png"
    },
    "CU":{
        "url":"https://i.ibb.co/S5D5V13/CU.png"
    },
    "CV":{
        "url":"https://i.ibb.co/Hqtsys0/CV.png"
    },
    "CW":{
        "url":"https://i.ibb.co/2YzQXnJ/CW.png"
    },
    "CX":{
        "url":"https://i.ibb.co/vqzd8Kw/CX.png"
    },
    "CY":{
        "url":"https://i.ibb.co/txTKbJQ/CY.png"
    },
    "CZ":{
        "url":"https://i.ibb.co/cy3RxKr/CZ.png"
    },
    "DE":{
        "url":"https://i.ibb.co/1vN467L/DE.png"
    },
    "DJ":{
        "url":"https://i.ibb.co/JsFv4kY/DJ.png"
    },
    "DK":{
        "url":"https://i.ibb.co/6g9bh56/DK.png"
    },
    "DM":{
        "url":"https://i.ibb.co/CsK0mY3/DM.png"
    },
    "DO":{
        "url":"https://i.ibb.co/sHhWM8t/DO.png"
    },
    "DZ":{
        "url":"https://i.ibb.co/1r9D8Qg/DZ.png"
    },
    "EC":{
        "url":"https://i.ibb.co/JCJChQk/EC.png"
    },
    "EE":{
        "url":"https://i.ibb.co/h9HpDcr/EE.png"
    },
    "EG":{
        "url":"https://i.ibb.co/02Pz66N/EG.png"
    },
    "EH":{
        "url":"https://i.ibb.co/5Tqp7YL/EH.png"
    },
    "ER":{
        "url":"https://i.ibb.co/3ShsBjS/ER.png"
    },
    "ES":{
        "url":"https://i.ibb.co/pR7dR0G/ES.png"
    },
    "ET":{
        "url":"https://i.ibb.co/ctZdLSg/ET.png"
    },
    "FI":{
        "url":"https://i.ibb.co/rsmhkJF/FI.png"
    },
    "FJ":{
        "url":"https://i.ibb.co/mBWwqsH/FJ.png"
    },
    "FK":{
        "url":"https://i.ibb.co/XbBj39f/FK.png"
    },
    "FM":{
        "url":"https://i.ibb.co/vkr4FgB/FM.png"
    },
    "FO":{
        "url":"https://i.ibb.co/z86JWYQ/FO.png"
    },
    "FR":{
        "url":"https://i.ibb.co/C0WG12k/FR.png"
    },
    "GA":{
        "url":"https://i.ibb.co/GtG4ZFX/GA.png"
    },
    "GB":{
        "url":"https://i.ibb.co/sW1QsG3/GB.png"
    },
    "GD":{
        "url":"https://i.ibb.co/bPz2WHd/GD.png"
    },
    "GE":{
        "url":"https://i.ibb.co/wrMRZ4m/GE.png"
    },
    "GG":{
        "url":"https://i.ibb.co/PQqtYTv/GG.png"
    },
    "GH":{
        "url":"https://i.ibb.co/K7gSGtQ/GH.png"
    },
    "GI":{
        "url":"https://i.ibb.co/yqx7QQ3/GI.png"
    },
    "GL":{
        "url":"https://i.ibb.co/pvtvJQp/GL.png"
    },
    "GM":{
        "url":"https://i.ibb.co/9n0zSYZ/GM.png"
    },
    "GN":{
        "url":"https://i.ibb.co/tzvMWH9/GN.png"
    },
    "GQ":{
        "url":"https://i.ibb.co/x5yk6cN/GQ.png"
    },
    "GR":{
        "url":"https://i.ibb.co/6XGd3yr/GR.png"
    },
    "GS":{
        "url":"https://i.ibb.co/G3FmT45/GS.png"
    },
    "GT":{
        "url":"https://i.ibb.co/b7vLZQx/GT.png"
    },
    "GU":{
        "url":"https://i.ibb.co/dMsWmJv/GU.png"
    },
    "GW":{
        "url":"https://i.ibb.co/31ynsx6/GW.png"
    },
    "GY":{
        "url":"https://i.ibb.co/TwB7Xvb/GY.png"
    },
    "HK":{
        "url":"https://i.ibb.co/M26TfP3/HK.png"
    },
    "HM":{
        "url":"https://i.ibb.co/F4kDWZK/HM.png"
    },
    "HN":{
        "url":"https://i.ibb.co/dGMCXFt/HN.png"
    },
    "HR":{
        "url":"https://i.ibb.co/Dgrpqcn/HR.png"
    },
    "HT":{
        "url":"https://i.ibb.co/Czqckp3/HT.png"
    },
    "HU":{
        "url":"https://i.ibb.co/NnMJYT3/HU.png"
    },
    "ID":{
        "url":"https://i.ibb.co/2tFxdrd/ID.png"
    },
    "IE":{
        "url":"https://i.ibb.co/SXf9hGF/IE.png"
    },
    "IL":{
        "url":"https://i.ibb.co/gM37BJz/IL.png"
    },
    "IM":{
        "url":"https://i.ibb.co/hRSCKFK/IM.png"
    },
    "IN":{
        "url":"https://i.ibb.co/dpxwm2Q/IN.png"
    },
    "IO":{
        "url":"https://i.ibb.co/VBDjsnH/IO.png"
    },
    "IQ":{
        "url":"https://i.ibb.co/ZTyptmV/IQ.png"
    },
    "IR":{
        "url":"https://i.ibb.co/GTRsMFP/IR.png"
    },
    "IS":{
        "url":"https://i.ibb.co/njr8yKJ/IS.png"
    },
    "IT":{
        "url":"https://i.ibb.co/0Qg7FJC/IT.png"
    },
    "JE":{
        "url":"https://i.ibb.co/QM2XT5W/JE.png"
    },
    "JM":{
        "url":"https://i.ibb.co/8dY8m1q/JM.png"
    },
    "JO":{
        "url":"https://i.ibb.co/cb9KzT2/JO.png"
    },
    "JP":{
        "url":"https://i.ibb.co/hg5KjmR/JP.png"
    },
    "KE":{
        "url":"https://i.ibb.co/VmWZ4Yr/KE.png"
    },
    "KG":{
        "url":"https://i.ibb.co/ftCY7Kt/KG.png"
    },
    "KH":{
        "url":"https://i.ibb.co/16Cr9Tw/KH.png"
    },
    "KI":{
        "url":"https://i.ibb.co/SDS2WQx/KI.png"
    },
    "KM":{
        "url":"https://i.ibb.co/q0M0XH6/KM.png"
    },
    "KN":{
        "url":"https://i.ibb.co/nggF87n/KN.png"
    },
    "KP":{
        "url":"https://i.ibb.co/GC7zn4n/KP.png"
    },
    "KR":{
        "url":"https://i.ibb.co/L0LvtkQ/KR.png"
    },
    "KW":{
        "url":"https://i.ibb.co/Sft3wSt/KW.png"
    },
    "KY":{
        "url":"https://i.ibb.co/NsJ7wt9/KY.png"
    },
    "KZ":{
        "url":"https://i.ibb.co/HVBc6fg/KZ.png"
    },
    "LA":{
        "url":"https://i.ibb.co/9v73TjS/LA.png"
    },
    "LB":{
        "url":"https://i.ibb.co/6JLdtKX/LB.png"
    },
    "LC":{
        "url":"https://i.ibb.co/TB71xzC/LC.png"
    },
    "LI":{
        "url":"https://i.ibb.co/0fvg0sy/LI.png"
    },
    "LK":{
        "url":"https://i.ibb.co/tMFd52X/LK.png"
    },
    "LR":{
        "url":"https://i.ibb.co/x5ShCFV/LR.png"
    },
    "LS":{
        "url":"https://i.ibb.co/KNnfQvW/LS.png"
    },
    "LT":{
        "url":"https://i.ibb.co/r5CStdH/LT.png"
    },
    "LU":{
        "url":"https://i.ibb.co/BGNPJJK/LU.png"
    },
    "LV":{
        "url":"https://i.ibb.co/9vg7DBK/LV.png"
    },
    "LY":{
        "url":"https://i.ibb.co/mtTVTpX/LY.png"
    },
    "MA":{
        "url":"https://i.ibb.co/3Y3Wj5s/MA.png"
    },
    "MC":{
        "url":"https://i.ibb.co/CnXbHZ8/MC.png"
    },
    "MD":{
        "url":"https://i.ibb.co/MgBpRkG/MD.png"
    },
    "ME":{
        "url":"https://i.ibb.co/bd33NG8/ME.png"
    },
    "MF":{
        "url":"https://i.ibb.co/4NCJpfL/MF.png"
    },
    "MG":{
        "url":"https://i.ibb.co/MNzzBMc/MG.png"
    },
    "MH":{
        "url":"https://i.ibb.co/gVDZKpd/MH.png"
    },
    "MK":{
        "url":"https://i.ibb.co/VtknTVR/MK.png"
    },
    "ML":{
        "url":"https://i.ibb.co/ZKqG38N/ML.png"
    },
    "MM":{
        "url":"https://i.ibb.co/J7zFmmK/MM.png"
    },
    "MN":{
        "url":"https://i.ibb.co/yqLn5PK/MN.png"
    },
    "MO":{
        "url":"https://i.ibb.co/F6RYQpt/MO.png"
    },
    "MP":{
        "url":"https://i.ibb.co/6nS2Q5F/MP.png"
    },
    "MQ":{
        "url":"https://i.ibb.co/SwyNwSs/MQ.png"
    },
    "MR":{
        "url":"https://i.ibb.co/tLWCP7V/MR.png"
    },
    "MS":{
        "url":"https://i.ibb.co/3pfmgr0/MS.png"
    },
    "MT":{
        "url":"https://i.ibb.co/n7Dv42T/MT.png"
    },
    "MU":{
        "url":"https://i.ibb.co/x6dyqHN/MU.png"
    },
    "MV":{
        "url":"https://i.ibb.co/gJpg04F/MV.png"
    },
    "MW":{
        "url":"https://i.ibb.co/dftMPgj/MW.png"
    },
    "MX":{
        "url":"https://i.ibb.co/vzZmPwZ/MX.png"
    },
    "MY":{
        "url":"https://i.ibb.co/ZLQSgY3/MY.png"
    },
    "MZ":{
        "url":"https://i.ibb.co/42mw8sR/MZ.png"
    },
    "NA":{
        "url":"https://i.ibb.co/NymGQSY/NA.png"
    },
    "NE":{
        "url":"https://i.ibb.co/2kxsh8X/NE.png"
    },
    "NF":{
        "url":"https://i.ibb.co/2WY6TN1/NF.png"
    },
    "NG":{
        "url":"https://i.ibb.co/19Gpn1x/NG.png"
    },
    "NI":{
        "url":"https://i.ibb.co/ccJxVtT/NI.png"
    },
    "NL":{
        "url":"https://i.ibb.co/1vJqbHM/NL.png"
    },
    "NP":{
        "url":"https://i.ibb.co/NNWHg37/NP.png"
    },
    "NR":{
        "url":"https://i.ibb.co/tCbd1kr/NR.png"
    },
    "NU":{
        "url":"https://i.ibb.co/HgQkVxh/NU.png"
    },
    "NZ":{
        "url":"https://i.ibb.co/6g5GyLb/NZ.png"
    },
    "OM":{
        "url":"https://i.ibb.co/qrtQQf7/OM.png"
    },
    "PA":{
        "url":"https://i.ibb.co/hHnGRrD/PA.png"
    },
    "PE":{
        "url":"https://i.ibb.co/bRSb6Kv/PE.png"
    },
    "PF":{
        "url":"https://i.ibb.co/HNFLvbY/PF.png"
    },
    "PG":{
        "url":"https://i.ibb.co/nsHP4H5/PG.png"
    },
    "PH":{
        "url":"https://i.ibb.co/7ykCb6Z/PH.png"
    },
    "PK":{
        "url":"https://i.ibb.co/QvJZNbP/PK.png"
    },
    "PL":{
        "url":"https://i.ibb.co/3mLWrXh/PL.png"
    },
    "PM":{
        "url":"https://i.ibb.co/0tmCvw1/PM.png"
    },
    "PN":{
        "url":"https://i.ibb.co/87JBN8q/PN.png"
    },
    "PR":{
        "url":"https://i.ibb.co/9qsSG9f/PR.png"
    },
    "PS":{
        "url":"https://i.ibb.co/jfwjKQT/PS.png"
    },
    "PT":{
        "url":"https://i.ibb.co/Y7Gn7yF/PT.png"
    },
    "PW":{
        "url":"https://i.ibb.co/myzzxLV/PW.png"
    },
    "PY":{
        "url":"https://i.ibb.co/CMkh1dV/PY.png"
    },
    "QA":{
        "url":"https://i.ibb.co/0XqVJC8/QA.png"
    },
    "RO":{
        "url":"https://i.ibb.co/FVj8Rx0/RO.png"
    },
    "RS":{
        "url":"https://i.ibb.co/m8W0dsL/RS.png"
    },
    "RU":{
        "url":"https://i.ibb.co/HYZRw0H/RU.png"
    },
    "RW":{
        "url":"https://i.ibb.co/mSkMgcP/RW.png"
    },
    "SA":{
        "url":"https://i.ibb.co/34JjLYp/SA.png"
    },
    "SB":{
        "url":"https://i.ibb.co/8D08MH3/SB.png"
    },
    "SC":{
        "url":"https://i.ibb.co/C8LRXN7/SC.png"
    },
    "SD":{
        "url":"https://i.ibb.co/mhy3WWg/SD.png"
    },
    "SE":{
        "url":"https://i.ibb.co/cwcrL7Q/SE.png"
    },
    "SG":{
        "url":"https://i.ibb.co/9Zqc6Qg/SG.png"
    },
    "SH":{
        "url":"https://i.ibb.co/18HMPfy/SH.png"
    },
    "SI":{
        "url":"https://i.ibb.co/BNYKRPW/SI.png"
    },
    "SK":{
        "url":"https://i.ibb.co/vV3YGKK/SK.png"
    },
    "SL":{
        "url":"https://i.ibb.co/wgytsNm/SL.png"
    },
    "SM":{
        "url":"https://i.ibb.co/QQCGpyD/SM.png"
    },
    "SN":{
        "url":"https://i.ibb.co/jfm4gsf/SN.png"
    },
    "SO":{
        "url":"https://i.ibb.co/RBjtLgP/SO.png"
    },
    "SR":{
        "url":"https://i.ibb.co/dGVchrb/SR.png"
    },
    "SS":{
        "url":"https://i.ibb.co/m0BgZV5/SS.png"
    },
    "ST":{
        "url":"https://i.ibb.co/vHmPpRh/ST.png"
    },
    "SV":{
        "url":"https://i.ibb.co/fv3NRcv/SV.png"
    },
    "SX":{
        "url":"https://i.ibb.co/LYHQ8jM/SX.png"
    },
    "SY":{
        "url":"https://i.ibb.co/pfqJg7H/SY.png"
    },
    "SZ":{
        "url":"https://i.ibb.co/PZ41ywB/SZ.png"
    },
    "TC":{
        "url":"https://i.ibb.co/KLhtxM5/TC.png"
    },
    "TD":{
        "url":"https://i.ibb.co/cY6NsLc/TD.png"
    },
    "TF":{
        "url":"https://i.ibb.co/zJHrkXM/TF.png"
    },
    "TG":{
        "url":"https://i.ibb.co/NT4dKvD/TG.png"
    },
    "TH":{
        "url":"https://i.ibb.co/4dvZt6M/TH.png"
    },
    "TJ":{
        "url":"https://i.ibb.co/kMqpq73/TJ.png"
    },
    "TL":{
        "url":"https://i.ibb.co/k5C1FKB/TL.png"
    },
    "TM":{
        "url":"https://i.ibb.co/B4PSN8j/TM.png"
    },
    "TN":{
        "url":"https://i.ibb.co/hskHPFP/TN.png"
    },
    "TO":{
        "url":"https://i.ibb.co/jkL82ky/TO.png"
    },
    "TR":{
        "url":"https://i.ibb.co/mc4yVW5/TR.png"
    },
    "TT":{
        "url":"https://i.ibb.co/HVH39XJ/TT.png"
    },
    "TV":{
        "url":"https://i.ibb.co/pb1FBsF/TV.png"
    },
    "TW":{
        "url":"https://i.ibb.co/h9BWt1X/TW.png"
    },
    "TZ":{
        "url":"https://i.ibb.co/bH2gcmh/TZ.png"
    },
    "UA":{
        "url":"https://i.ibb.co/10LRH0j/UA.png"
    },
    "UG":{
        "url":"https://i.ibb.co/n1dM6tN/UG.png"
    },
    "UM":{
        "url":"https://i.ibb.co/qg6fkrp/UM.png"
    },
    "UY":{
        "url":"https://i.ibb.co/ft15PNS/UY.png"
    },
    "UZ":{
        "url":"https://i.ibb.co/3stR2Q4/UZ.png"
    },
    "VA":{
        "url":"https://i.ibb.co/FbbYzc3/VA.png"
    },
    "VC":{
        "url":"https://i.ibb.co/W5Kqm5h/VC.png"
    },
    "VE":{
        "url":"https://i.ibb.co/WxfzLZF/VE.png"
    },
    "VG":{
        "url":"https://i.ibb.co/8d7S5fN/VG.png"
    },
    "VI":{
        "url":"https://i.ibb.co/PDvzLKs/VI.png"
    },
    "VN":{
        "url":"https://i.ibb.co/hm19G2T/VN.png"
    },
    "VU":{
        "url":"https://i.ibb.co/3CNTJpx/VU.png"
    },
    "WF":{
        "url":"https://i.ibb.co/Vq6Z975/WF.png"
    },
    "WS":{
        "url":"https://i.ibb.co/FKpq6Lh/WS.png"
    },
    "YE":{
        "url":"https://i.ibb.co/7ggYFvy/YE.png"
    },
    "YT":{
        "url":"https://i.ibb.co/zSdHrJf/YT.png"
    },
    "ZA":{
        "url":"https://i.ibb.co/P9WZRJK/ZA.png"
    },
    "ZM":{
        "url":"https://i.ibb.co/MMMbY47/ZM.png"
    },
    "ZW":{
        "url":"https://i.ibb.co/f9FJKp1/ZW.png"
    },
    "GF": {
        "url":"https://i.ibb.co/C0WG12k/FR.png"
    },
    "GP": {
        "url":"https://i.ibb.co/C0WG12k/FR.png"
    },
    "NC": {
        "url":"https://i.ibb.co/C0WG12k/FR.png"
    },
    "NO": {
        "url":"https://i.ibb.co/7ymsm1C/BV.png"
    },
    "RE": {
        "url":"https://i.ibb.co/C0WG12k/FR.png"
    },
    "SJ": {
        "url":"https://i.ibb.co/7ymsm1C/BV.png"
    },
    "TK": {
        "url":"https://i.ibb.co/6g5GyLb/NZ.png"
    },
    "US": {
        "url":"https://i.ibb.co/qg6fkrp/UM.png"
    }

};